module.exports = __webpack_public_path__ + "img/pageBanner-facilitiesService.773a9e8f.jpg";